import { i, s, x } from '../../lit-element.js';
import { reset } from '../../styles/reset.style.js';
import { forms } from '../../styles/forms.style.js';
import { radioButtons } from '../../styles/radio-buttons.style.js';

const style = i`
  :host {
    display: block;
    font-size: 16px;
    margin-bottom: 3em;
  }

  :host([hidden]) {
    display: none;
  }

  p {
    margin-bottom: 1em;
  }

  .error-caption {
    color: #ba2629;
    font-size: 0.75em;
    margin-bottom: 1em;
  }
`;

class RefiVerifyIdQuizQuestion extends s {
  static get properties() {
    return {
      question: { type: Object, attribute: true },
      showError: { type: Boolean },
    };
  }

  static get styles() {
    return [reset, forms, radioButtons, style];
  }

  render() {
    return x`
      <p>${this.question.questionText}</p>
      ${this.showError ? x`<p class="error-caption">Please select an answer</p>` : ''}
      ${this.question.questionChoices.map(
        choice => x`
          <div class="grv-form-field">
            <input
              type="radio"
              id="question${this.question.questionId}answer${choice.choiceNumber}"
              name="question${this.question.questionId}"
              class="grv-radio"
              .value="${choice.choiceNumber}"
              @input="${this.setErrMessage}"
              @invalid="${this.setErrMessage}"
              required
            />
            <label class="grv-radio-label" for="question${this.question.questionId}answer${choice.choiceNumber}">${choice.choiceText}</label>
          </div>
        `,
      )}
    `;
  }

  setErrMessage(ev) {
    this.showError = Boolean(ev.target.validationMessage);
  }
}

export { RefiVerifyIdQuizQuestion };
